import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext({
  theme: "dark",
  isDark: true,
  setTheme: () => {},
  toggleTheme: () => {},
});

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    try {
      return localStorage.getItem("app_theme") || "dark";
    } catch {
      return "dark";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("app_theme", theme);
    } catch (e) {
      console.error("Theme save error:", e);
    }

    const root = document.documentElement;
    const body = document.body;

    if (theme === "light") {
      root.classList.add("theme-light");
      root.classList.remove("theme-dark");
      body.classList.add("theme-light");
      body.classList.remove("theme-dark");
      body.style.backgroundColor = "#f4f6f9";
      body.style.color = "#0f172a";
    } else {
      root.classList.add("theme-dark");
      root.classList.remove("theme-light");
      body.classList.add("theme-dark");
      body.classList.remove("theme-light");
      body.style.backgroundColor = "#000000";
      body.style.color = "#ffffff";
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <ThemeContext.Provider
      value={{
        theme,
        isDark: theme !== "light",
        setTheme,
        toggleTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}

